(() => {
  const STATUS_TEXT = { bon: 'Bon', moyen: 'Moyen', faible: 'Faible' };
  const SEVERITY = { bon: 'good', moyen: 'medium', faible: 'poor' };

  const CATEGORIES = [
    { key: 'performance', name: 'Performance' },
    { key: 'accessibility', name: 'Accessibilité' },
    { key: 'bestPractices', name: 'Bonnes pratiques' },
    { key: 'seo', name: 'SEO' },
  ];

  const SVG_NS = 'http://www.w3.org/2000/svg';
  const GAUGE_RADIUS = 56;
  const GAUGE_CIRCUMFERENCE = 2 * Math.PI * GAUGE_RADIUS;

  const dateFormatter = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'long', timeStyle: 'short' });

  let instanceCounter = 0;

  function shapeMarker(severity) {
    const span = document.createElement('span');
    span.className = `tapn-score-page__legend-shape tapn-score-page__legend-shape--${severity}`;
    return span;
  }

  // Icône de statut par check (Heroicons outline, demande d'Amine 2 septembre
  // 2026) : check nu si réussi (option 4, la plus minimale — sans cercle),
  // triangle d'alerte si échec — le triangle reprend la forme "poor" déjà
  // utilisée dans la légende en haut de page.
  const CHECK_PATH = 'm4.5 12.75 6 6 9-13.5';
  const EXCLAMATION_TRIANGLE_PATH = 'M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z';

  function checkStatusIcon(passed) {
    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('tapn-score-page__breakdown-check-icon');
    const path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    path.setAttribute('d', passed ? CHECK_PATH : EXCLAMATION_TRIANGLE_PATH);
    svg.appendChild(path);
    return svg;
  }

  function buildGauge(score, severity) {
    const wrap = document.createElement('div');
    wrap.className = 'tapn-score-page__gauge';

    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 120 120');
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('tapn-score-page__gauge-ring');

    const track = document.createElementNS(SVG_NS, 'circle');
    track.setAttribute('cx', '60');
    track.setAttribute('cy', '60');
    track.setAttribute('r', String(GAUGE_RADIUS));
    track.classList.add('tapn-score-page__gauge-track');

    const progress = document.createElementNS(SVG_NS, 'circle');
    progress.setAttribute('cx', '60');
    progress.setAttribute('cy', '60');
    progress.setAttribute('r', String(GAUGE_RADIUS));
    progress.setAttribute('transform', 'rotate(-90 60 60)');
    progress.classList.add('tapn-score-page__gauge-progress');
    if (severity) progress.dataset.severity = severity;
    const ratio = typeof score === 'number' ? Math.max(0, Math.min(100, score)) / 100 : 0;
    progress.setAttribute('stroke-dasharray', String(GAUGE_CIRCUMFERENCE));
    progress.setAttribute('stroke-dashoffset', String(GAUGE_CIRCUMFERENCE * (1 - ratio)));

    svg.append(track, progress);

    const value = document.createElement('span');
    value.className = 'tapn-score-page__gauge-value';
    value.textContent = typeof score === 'number' ? String(score) : '—';

    wrap.append(svg, value);
    return wrap;
  }

  function initScoreSite(root = document) {
    root.querySelectorAll('[data-tapn-score-site]:not([data-tapn-score-bound])').forEach((page) => {
      page.dataset.tapnScoreBound = 'true';
      const instanceId = instanceCounter++;

      const form = page.querySelector('.tapn-score-page__form');
      const input = form?.querySelector('#TapnScoreUrl');
      const submit = page.querySelector('[data-tapn-score-submit]');
      const loading = page.querySelector('[data-tapn-score-loading]');
      const formError = page.querySelector('[data-tapn-score-form-error]');
      const formErrorMessage = page.querySelector('[data-tapn-score-form-error-message]');
      const result = page.querySelector('[data-tapn-score-result]');
      const resultMeta = page.querySelector('[data-tapn-score-meta]');
      const resultScores = page.querySelector('[data-tapn-score-scores]');
      const resultBreakdown = page.querySelector('[data-tapn-score-breakdown]');
      if (!form || !input || !submit) return;

      const showFormError = (message) => {
        if (!formError || !formErrorMessage) return;
        formErrorMessage.textContent = message;
        formError.hidden = false;
      };

      const clearFormError = () => {
        if (!formError || !formErrorMessage) return;
        formErrorMessage.textContent = '';
        formError.hidden = true;
      };

      // Pendant l'analyse : bouton grisé (pas de double envoi) et loader à la place du rapport.
      const setSubmitState = (isLoading) => {
        submit.disabled = isLoading;
        submit.setAttribute('aria-busy', String(isLoading));
        if (!loading) return;
        loading.hidden = !isLoading;
        if (isLoading) loading.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      };

      const renderMeta = (meta) => {
        if (!resultMeta) return;
        resultMeta.replaceChildren();

        const dateLine = document.createElement('p');
        dateLine.textContent = meta?.fetchTime
          ? `Rapport du ${dateFormatter.format(new Date(meta.fetchTime))} – Analyse effectuée sur la version mobile.`
          : 'Analyse effectuée sur la version mobile.';
        resultMeta.appendChild(dateLine);

        if (meta?.finalUrl) {
          const urlLine = document.createElement('p');
          urlLine.append('URL analysée : ');
          const urlValue = document.createElement('em');
          urlValue.textContent = meta.finalUrl;
          urlLine.appendChild(urlValue);
          resultMeta.appendChild(urlLine);
        }
      };

      // Section de détail : toujours présente et visible pour les 4 catégories
      // (pas d'accordéon), la jauge au-dessus y renvoie par ancre. Chaque check
      // curaté est listé nommément, réussi ou non — jamais un compte sans dire
      // ce qui a été vérifié (demande d'Amine, 2 septembre 2026).
      const buildSection = (key, name, entry, group, sectionId) => {
        const severity = (entry?.label && SEVERITY[entry.label]) || null;
        const checks = group?.checks || [];

        const section = document.createElement('section');
        section.className = 'tapn-score-page__breakdown-group';
        section.id = sectionId;
        if (severity) section.dataset.severity = severity;

        const title = document.createElement('h2');
        title.className = 'tapn-score-page__breakdown-title';
        if (severity) title.appendChild(shapeMarker(severity));
        const titleText = document.createElement('span');
        titleText.textContent = entry?.score != null ? `${name} · ${entry.score}/100` : name;
        title.appendChild(titleText);
        section.appendChild(title);

        if (checks.length === 0) {
          const summary = document.createElement('p');
          summary.className = 'tapn-score-page__breakdown-summary';
          summary.textContent = 'Aucune donnée disponible sur les points que nous vérifions pour cette catégorie.';
          section.appendChild(summary);
          return section;
        }

        const list = document.createElement('ul');
        list.className = 'tapn-score-page__breakdown-list';
        checks.forEach((check) => {
          const item = document.createElement('li');
          item.className = 'tapn-score-page__breakdown-check';
          item.dataset.passed = String(check.passed);
          item.appendChild(checkStatusIcon(check.passed));

          const label = document.createElement('p');
          label.className = 'tapn-score-page__breakdown-check-label';
          label.textContent = check.label;
          item.appendChild(label);

          if (!check.passed && check.message) {
            const message = document.createElement('p');
            message.className = 'tapn-score-page__breakdown-check-message';
            message.textContent = check.message;
            item.appendChild(message);
          }

          if (!check.passed && check.stat) {
            const stats = document.createElement('div');
            stats.className = 'tapn-score-page__breakdown-check-stats';

            if (check.stat.kind === 'metric' && check.stat.text) {
              const badge = document.createElement('span');
              badge.className = 'tapn-score-page__stat-badge';
              badge.textContent = check.stat.text;
              stats.appendChild(badge);
            } else if (check.stat.kind === 'items') {
              (check.stat.items || []).forEach((cite) => {
                const badge = document.createElement('span');
                badge.className = 'tapn-score-page__stat-badge';
                badge.textContent = cite;
                stats.appendChild(badge);
              });
            }

            item.appendChild(stats);
          }

          list.appendChild(item);
        });
        section.appendChild(list);

        return section;
      };

      const renderResult = (data) => {
        if (!result || !resultScores || !resultBreakdown) return;

        renderMeta(data.meta);

        resultScores.replaceChildren();
        resultBreakdown.replaceChildren();

        CATEGORIES.forEach(({ key, name }) => {
          const entry = data.scores?.[key];
          const group = data.findings?.[key];
          const severity = (entry?.label && SEVERITY[entry.label]) || null;
          const sectionId = `tapn-score-section-${key}-${instanceId}`;

          resultBreakdown.appendChild(buildSection(key, name, entry, group, sectionId));

          const tile = document.createElement('a');
          tile.href = `#${sectionId}`;
          tile.className = 'tapn-score-page__score-tile';
          if (severity) tile.dataset.severity = severity;

          const nameEl = document.createElement('p');
          nameEl.className = 'tapn-score-page__score-name';
          nameEl.textContent = name;

          const statusEl = document.createElement('p');
          statusEl.className = 'tapn-score-page__score-status';
          if (severity) statusEl.appendChild(shapeMarker(severity));
          const statusText = document.createElement('span');
          statusText.textContent = entry?.label ? STATUS_TEXT[entry.label] || '' : '—';
          statusEl.appendChild(statusText);

          tile.append(buildGauge(entry?.score, severity), nameEl, statusEl);
          resultScores.appendChild(tile);
        });

        result.hidden = false;
        result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      };

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        clearFormError();
        if (result) result.hidden = true;

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        setSubmitState(true);

        try {
          const endpoint = new URL(form.dataset.scoreEndpoint);
          endpoint.searchParams.set('url', input.value.trim());

          let response;
          try {
            response = await fetch(endpoint.toString(), { method: 'GET', credentials: 'omit' });
          } catch {
            throw new Error("Impossible de contacter le service d'analyse. Réessayez dans quelques instants.");
          }

          const payload = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(payload.error || "L'analyse a échoué. Réessayez.");

          renderResult(payload);
        } catch (error) {
          showFormError(error instanceof Error ? error.message : "L'analyse a échoué. Réessayez.");
        } finally {
          setSubmitState(false);
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initScoreSite());
  else initScoreSite();

  document.addEventListener('shopify:section:load', (event) => initScoreSite(event.target));
})();
